// eslint-disable-next-line import/prefer-default-export

import React from 'react';
import PropTypes from 'prop-types';
import Shoe from '../../images/shoe.svg';
import { UserWrapper } from './ErrorPage.style';


function ErrorPage({ userName }) {
  return (
    <div className="ncss-row ta-sm-c va-sm-m" >
      <div className="ncss-col-sm-7 mt12-sm">
        <img
          src={Shoe}
          alt=""
          style={{
            position: 'relative',
            left: '42%',
            height: "226px",
            width: "113px"
          }}
        />
        <p className="ta-sm-c pl6-sm u-medium + ncss-base + ( fs30-sm or fs36-lg )" >
          Uh-Oh. We Couldn&apos;t Find a Match
        </p>
        <p
          className="ta-sm-c fs16-sm pt5-sm text-color-dark-grey"
        >
          You may not have access to this resource, or you may need to check the URL for a typo.
        </p>
        {userName && (
          <UserWrapper>
            {userName}
          </UserWrapper>
        )}
        <a
          href="/login"
          style={{
            background: '#111',
            color: '#ffffff',
            /* top | right | bottom | left */
            padding: "5px 3em 5px 3em",
            margin: '2em',
            display: 'inline-block',
            borderRadius: '5em',
            fontSize: '16px',
          }}
        >
          Go Back
        </a>
      </div>
    </div >
  );
}

ErrorPage.propTypes = {
  userName: PropTypes.string,
};

ErrorPage.defaultProps = {
  userName: '',
};

export default ErrorPage;


// WEBPACK FOOTER //
// ./src/containers/ErrorPage/ErrorPage.js